import * as dom from './wpstg-dom-utils.js';

export default class WpstgMainMenu {
  constructor() {
    this.activeTabClass = 'wpstg--tab--active';
    this.mainMenu();
  }

  mainMenu() {
    const tabHeader = dom.qs('.wpstg--tab--header');
    // Early bail if tab header is not available
    if (tabHeader === null) {
      return;
    }

    dom.addEvent(dom.qs('.wpstg--tab--header'), 'click', '.wpstg-button', (element) => {
      const $this = element;
      const target = $this.getAttribute('data-target');
      if (target === '') {
        return;
      }
      const targetElements = dom.all(target);
      const menuItems = dom.all('.wpstg--tab--header a[data-target]');
      const contents = dom.all('.wpstg--tab--contents > .wpstg--tab--content');

      contents.forEach((content) => {
        // active tab class is without the css dot class prefix
        if (content.matches('.' + this.activeTabClass + ':not(' + target + ')')) {
          content.classList.remove(this.activeTabClass);
        }
      });

      menuItems.forEach((menuItem) => {
        if (menuItem !== $this) {
          menuItem.classList.remove(this.activeTabClass);
        }
      });

      $this.classList.add(this.activeTabClass);

      targetElements.forEach((targetElement) => {
        targetElement.classList.add(this.activeTabClass);
      });

      if ('#wpstg--tab--backup' === target) {
        window.dispatchEvent(new Event('backups-tab'));
      }
    });
  };
}
